// extracted by mini-css-extract-plugin
module.exports = {"small":"Button_small__3YyyL","medium":"Button_medium__K6-R-","large":"Button_large__jJWDb"};